import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { ChatService, CompanyService } from '../../services';
import { AppFilter } from '@app/shared/models';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

interface INewChatModalContext {
  services: any;
}

@Component({
  selector: 'app-new-chat-modal',
  templateUrl: './new-chat-modal.component.html',
  styleUrls: ['./new-chat-modal.component.scss'],
})
export class NewChatModalComponent implements OnInit {
  user: any;
  organizationId: any;

  error: any;
  success: any;
  pending: boolean = false;
  selectedServiceTypeName: string;

  servicesAndSubGroupsForm: FormGroup;
  selectedServiceType: string = '';
  selectedServiceSubType: string = '';

  allOrganizations;
  allTopics;
  allSubTopics;
  filteredTopics;
  filteredSubTopics;

  stepOne = true;
  stepTwo = false;

  companies: FormGroup;
  selectedCompanyName: string = '';

  filter: AppFilter = new AppFilter({ rows: 10000 });
  searchText: string = '';
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'organizationShortName',
        op: 'cn',
        data: '',
      },
    ],
  };

  constructor(
    public modal: SuiModal<INewChatModalContext, void, void>,
    private router: Router,
    private fb: FormBuilder,
    private chatService: ChatService,
    private companySvc: CompanyService
  ) {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.organizationId = this.user['organizationId'];

    this.servicesAndSubGroupsForm = fb.group({
      serviceType: [''],
      subServiceType: [''],
    });

    this.companies = fb.group({
      searchText: [],
      companyName: [''],
    });

    this.companies
      .get('searchText')
      .valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchText) => {
        this.onSearchRecords(searchText);
      });
  }

  ngOnInit(): void {
    this.getCompanies();
  }

  createSession() {
    this.pending = true;
    let selectedCompanyData = this.allOrganizations.find(
      (member) => member.organizationShortName == this.selectedCompanyName
    );
    this.chatService
      .createChatSession({
        subTopicId: this.servicesAndSubGroupsForm.value.subServiceType,
        organizationId: selectedCompanyData.organizationId,
        body: {
          // organizationIds: data.map((member) => member.organizationId),
        },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Chat session Successfully created';
          setTimeout(() => {
            this.modal.approve(null);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.message
            ? error.error.message
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getTopics(): void {
    this.pending = true;
    this.chatService.getAssignedChatTopics({}).subscribe(
      (res) => {
        this.allTopics = res;
        this.pending = false;
      },
      (error) => {
        console.log(error);
        this.pending = false;
      }
    );
  }

  getSub(id): void {
    this.pending = true;
    this.chatService.getAssignedChatSubTopics({ topicId: id }).subscribe(
      (res) => {
        this.allSubTopics = res;
        this.pending = false;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error;
      }
    );
  }

  getAssignedSubTopics(): void {
    this.chatService
      .getAssignedChatSubTopicsPerUser({
        appUserId: this.user['appUserId'],
      })
      .subscribe(
        (res) => {
          // this.allTopics = res;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getCompanies(): void {
    this.filter.rows = 10000;
    this.pending = true;
    this.companySvc.getOrganization({ params: this.filter }).subscribe(
      (res) => {
        this.allOrganizations = res['rows'];
        this.getTopics();
        this.pending = false;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error;
      }
    );
  }

  onSearchRecords(search) {
    // console.log(search);
    this.searchFilter.rules[0].data = search;
    this.filter._search = true;
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.getCompanies();
  }

  cancel() {
    if (this.stepOne == false && this.stepTwo == true) {
      this.stepTwo = false;
      this.stepOne = true;
    } else {
      this.modal.deny(undefined);
    }
  }

  continue() {
    this.stepOne = false;
    this.stepTwo = true;
  }

  submit() {
    if (this.servicesAndSubGroupsForm.valid) {
      this.createSession();
    }
    // navigate and add to route params
    // so it can be displayed
    // create array to be updated for every new chat by pushing to the beginning not the end
    // this.router.navigate(
    // 	[
    // 		"/admin/new-chat",
    // 		// "conversation-screen"
    // 	],
    // 	{
    // 		queryParams: {
    // 			id: 5,
    // 			// userType: getUserType(this.selectedCompanyName),
    // 			sessionType: "PU",
    // 			company: this.selectedCompanyName,
    // 			service: this.getName(this.selectedServiceType),
    // 			subService: this.getName(this.selectedServiceSubType),
    // 			lastActivity: Date.now().toString(),
    // 			status: "active",
    // 			watched: false,
    // 		},
    // 	}
    // );
    // this.modal.approve();
  }

  changeName(org: string) {
    this.selectedCompanyName = org;
    // this.filteredTopics = this.allTopics.filter((item) => {
    //   // get topics for selected company
    //   return item.topic.organization.organizationShortName === org;
    // });
    // console.log(this.filteredTopics);
  }

  changeType(topicId) {
    this.selectedServiceType = topicId;
    // console.log(this.selectedServiceType, this.allSubTopics, 'type');
    this.getSub(topicId);
    // this.filteredSubTopics = this.allSubTopics.filter((item) => {
    //   return item.topic.topicId === topicId;
    // });
    // console.log(this.filteredSubTopics);
  }

  changeSubType(event) {
    switch (event) {
      case 'new-type':
        this.selectedServiceSubType = 'new-type';
        //action
        break;
      case 'archived':
        this.selectedServiceSubType = 'archived';
        break;
      case 'new':
        this.selectedServiceSubType = 'new';
        break;
      case 'renewal':
        this.selectedServiceSubType = 'renewal';
        break;
      case 'ftp':
        this.selectedServiceSubType = 'ftp';
        break;
      case 'activity':
        this.selectedServiceSubType = 'activity';
        break;
      case 'payment':
        this.selectedServiceSubType = 'payment';
        break;
      case 'task':
        this.selectedServiceSubType = 'task';
    }
  }

  getName(id: string): string {
    let name;

    if (id == 'typeApprovalEquipment') {
      name = 'Type Approval Equipment';
    } else if (id == 'licensingService') {
      name = 'Licensing Service';
    } else if (id == 'complianceService') {
      name = 'Compliance Service';
    } else if (id == 'accountManagementService') {
      name = 'Account Management Service';
    } else if (id == 'new-type') {
      name = 'New Type Approval Equipment';
    } else if (id == 'archived') {
      name = 'Archived Type Approval Equipment';
    } else if (id == 'new') {
      name = 'New Licensing Service';
    } else if (id == 'renewal') {
      name = 'Renewal Licensing Service';
    } else if (id == 'ftp') {
      name = 'Compliance FTP Data Submission';
    } else if (id == 'activity') {
      name = 'Activity Data Submission';
    } else if (id == 'payment') {
      name = 'User Payment Service';
    } else if (id == 'task') {
      name = 'User Task Service';
    }

    return name;
  }

  dataToJSON(data: any) {
    return JSON.parse(data);
  }
}

export class NewChatModal extends ComponentModalConfig<
  INewChatModalContext,
  void,
  void
> {
  constructor(services: any, size: ModalSize = ModalSize.Mini) {
    super(NewChatModalComponent, { services });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
